import React from 'react';

import { GlyphContainer, ImageContainer, NameContainer } from './Glyph.style';
import type { WhatWeTreatGlyphType } from '../WhatWeTreat';

export const Glyph = ({ content }: { content: WhatWeTreatGlyphType }) => {
  const { name, glyph } = content;

  return (
    <GlyphContainer>
      <ImageContainer>{glyph}</ImageContainer>
      <NameContainer>{name}</NameContainer>
    </GlyphContainer>
  );
};
